export const environment = {
  // apiUrl: 'https://qswckgwcwwckc44k848o4kkg.is-on.cloud/api/v1',
  // apiUrl: 'https://ys440sg844kg8oockc4cwsos.is-on.cloud/api/v1',
  apiUrl: 'http://localhost:8000/api/v1',
  // apiUrl: 'https://api.gamersbrawl.com/api/v1',
};

